/**
 * @fileoverview This file defines a tool for requesting user input via the console. It provides a function that prompts the user and returns their response.
 */

import { ToolDefinition } from '@iterator/shared-node/ai/llm_types'
import { getUserInput as getConsoleInput } from '../console_chat'

export const getUserInputTool: ToolDefinition = {
  name: 'request_user_input',
  function: {
    name: 'request_user_input',
    description: 'Request input from the user via console or editor',
    parameters: {
      type: 'object',
      properties: {
        prompt: {
          type: 'string',
          description: 'Optional prompt to show the user',
        },
      },
      required: [],
    },
  },
  execute: async (args) => {
    const { prompt } = args as { prompt?: string }
    const input = await getConsoleInput(prompt)
    return input
  },
}
